__turbopack_context__.v({
  "alwaysActive": "CookieConsent-module__zb7eDq__alwaysActive",
  "banner": "CookieConsent-module__zb7eDq__banner",
  "bannerContent": "CookieConsent-module__zb7eDq__bannerContent",
  "bannerInner": "CookieConsent-module__zb7eDq__bannerInner",
  "btnGroup": "CookieConsent-module__zb7eDq__btnGroup",
  "btnbox": "CookieConsent-module__zb7eDq__btnbox",
  "closeBtn": "CookieConsent-module__zb7eDq__closeBtn",
  "constumModalhead": "CookieConsent-module__zb7eDq__constumModalhead",
  "cookieSection": "CookieConsent-module__zb7eDq__cookieSection",
  "cookiedesc": "CookieConsent-module__zb7eDq__cookiedesc",
  "cookiehead": "CookieConsent-module__zb7eDq__cookiehead",
  "desktopOnly": "CookieConsent-module__zb7eDq__desktopOnly",
  "fadeIn": "CookieConsent-module__zb7eDq__fadeIn",
  "mobileOnly": "CookieConsent-module__zb7eDq__mobileOnly",
  "modal": "CookieConsent-module__zb7eDq__modal",
  "modalContent": "CookieConsent-module__zb7eDq__modalContent",
  "modalContent2": "CookieConsent-module__zb7eDq__modalContent2",
  "modalFooter": "CookieConsent-module__zb7eDq__modalFooter",
  "modalHeader": "CookieConsent-module__zb7eDq__modalHeader",
  "outlineBtn": "CookieConsent-module__zb7eDq__outlineBtn",
  "overlay": "CookieConsent-module__zb7eDq__overlay",
  "pointshead": "CookieConsent-module__zb7eDq__pointshead",
  "primaryBtn": "CookieConsent-module__zb7eDq__primaryBtn",
  "sectionDesc": "CookieConsent-module__zb7eDq__sectionDesc",
  "sectionHeader": "CookieConsent-module__zb7eDq__sectionHeader",
  "slideUp": "CookieConsent-module__zb7eDq__slideUp",
  "slider": "CookieConsent-module__zb7eDq__slider",
  "stickfooter": "CookieConsent-module__zb7eDq__stickfooter",
  "stickhead": "CookieConsent-module__zb7eDq__stickhead",
  "switch": "CookieConsent-module__zb7eDq__switch",
});
